import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useResetAdminStaffPassword = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('resetAdminStaffPassword', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['admin-staff'] });
      toast.success(res.message);
    },
    onError: (error) => toast.error(error.message),
  });
  return { mutateAsync };
};
export default useResetAdminStaffPassword;
